import React from "react";
import { Icon } from "./Icon.jsx";

const TONES = { blue: "--ac-blue", green: "--ac-green", amber: "--ac-amber", red: "--ac-red", violet: "--ac-violet", teal: "--ac-teal", indigo: "--ac-indigo", gold: "--ac-amber-3", neutral: "--fg-6" };

export function IconTile({ icon, tone = "blue", size = 26, style = {} }) {
  const c = "var(" + (TONES[tone] || TONES.blue) + ")";
  return (
    <span style={{
      flex: "none", display: "flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "var(--r-tile)",
      background: tone === "neutral" ? "var(--bg-chip)" : "color-mix(in srgb, " + c + " 12%, transparent)",
      color: c, ...style,
    }}><Icon name={icon} size={Math.round(size * 0.54)} /></span>
  );
}
